/* 🤖 this file was generated by svg-to-ts */
export const siriusFlagTh: {
  name: 'flag_th';
  data: string;
} = {
  name: 'flag_th',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 24" style="display: block;"><g clip-path="url(#a)"><path fill="#F4F5F8" d="M0 0h32v24H0V0Z"/><path fill="#2D2A4A" d="M0 8.125h32v8H0v-8Z"/><path fill="#A51931" d="M0 0h32v4.125H0V0Zm0 20h32v4H0v-4Z"/></g><rect width="31" height="23" x=".5" y=".5" stroke="#000" stroke-opacity=".2" rx="2.5"/><defs><clipPath id="a"><rect width="32" height="24" fill="#fff" rx="3"/></clipPath></defs></svg>`
};
